import cloneDeep from 'lodash/cloneDeep';
export const extractOverlap = (source, comparison) => {
    const result = {};
    for (const key in source) {
        if (key in comparison) {
            const sourceValue = source[key];
            const comparisonValue = comparison[key];
            if (Array.isArray(sourceValue)) {
                result[key] = cloneDeep(sourceValue);
            }
            else if (typeof sourceValue === 'object' &&
                sourceValue !== null &&
                typeof comparisonValue === 'object' &&
                comparisonValue !== null) {
                const nestedOverlap = extractOverlap(sourceValue, comparisonValue);
                if (Object.keys(nestedOverlap).length > 0) {
                    result[key] = nestedOverlap;
                }
            }
            else if (sourceValue !== comparisonValue) {
                result[key] = cloneDeep(sourceValue);
            }
        }
    }
    return result;
};
//# sourceMappingURL=extractOverlap.js.map